"use client";
import { useFormik } from "formik";
import { useState } from "react";
import { object, string } from "yup";
import CustomSpinner from "../CustomSpinner/CustomSpinner";
import { sendMessageToAdmin } from "@/services/UserService";
import { useUserContext } from "@/context/UserContext";
import { NewInboxAdminI } from "@/interfaces/Inbox";
import { notifyError, notifySuccess } from "@/utils/NotificationFunctions";

const SendMessageSchema = object({
  title: string().required("This field is required"),
  message: string().required("This field is required"),
});

interface SendMessageToAdminPropsI {
  onHide?: () => void;
}

function SendMessageToAdmin({ onHide }: SendMessageToAdminPropsI) {
  const [loading, setLoading] = useState<boolean>(false);

  const { currentUser, userToken } = useUserContext();

  const formik = useFormik({
    initialValues: {
      title: "",
      message: "",
    },
    validationSchema: SendMessageSchema,
    onSubmit: async (values) => {
      setLoading(true);
      const inboxData: NewInboxAdminI = {
        userId: currentUser!._id,
        status: "new",
        handleBy: null,
        title: values.title,
        message: values.message,
        chatId: null,
      };
      await sendMessageToAdmin(inboxData, userToken)
        .then((res) => {
          if (res && res.status === 200) {
            notifySuccess(res.data.message);
          } else if (res) {
            notifyError(res.data.message);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          onHide?.();
          setLoading(false);
        });
    },
  });

  const { errors, touched } = formik;

  return (
    <form
      className="send-message-to-admin-form-component d-flex flex-column gap-4"
      onSubmit={formik.handleSubmit}
    >
      <div className="form-row d-flex flex-column gap-2">
        <label htmlFor="title">Title</label>
        <input
          className="standar"
          type="text"
          id="title"
          name="title"
          value={formik.values.title}
          onChange={formik.handleChange}
          placeholder="title"
        />
        {errors.title && touched.title && (
          <div className="form-error">{errors.title}</div>
        )}
      </div>
      <div className="form-row d-flex flex-column gap-2">
        <label htmlFor="message">Message</label>
        <textarea
          name="message"
          id="message"
          placeholder="Write here your message"
          value={formik.values.message}
          onChange={formik.handleChange}
          rows={10}
        />
        {errors.message && touched.message && (
          <div className="form-error">{errors.message}</div>
        )}
      </div>
      <button className="btn linear-bg" type="submit">
        {loading ? <CustomSpinner size={1.6} borderWidth={2} /> : "Send"}
      </button>
    </form>
  );
}

export default SendMessageToAdmin;
